import PouchActions from "app/actions/pouch.actions";
import { PouchDocType } from "shared-types/ActionsTypes";
import { loadSchedules, setSelectedSchedule } from "app/reducers/schedule/slice";
import { AppDispatch } from 'appRoot/Store';


export function handlePouchUpdates(dispatch: AppDispatch) {

  PouchActions.handlePouchSyncedDoctype(PouchDocType.schedule, (evt, payload) => {
    console.log('schedule updated...', payload)
    dispatch(loadSchedules())
    dispatch(setSelectedSchedule({ useCachedScheduleLookup: false }));

  });
  PouchActions.handlePouchSyncedDoctype(PouchDocType.event, (evt, payload) => {
    console.log('event updated...', payload)
    dispatch(setSelectedSchedule({ useCachedScheduleLookup: false }));
  });
}
